import Footer from "./Footer";
import Header from "./Header";
import VerificationBanner from "./VerificationBanner";

export default function SidebarLayout(props) {
  return <> <Header />
    {props.children}
    <Footer /></>;
}
